<template>
	<div class="item">
		<label :for="item" class="label" v-text="label"/>
		<slot/>
		<div class="error" v-if="error" v-text="error"/>
	</div>
</template>

<script>
import {get} from "lodash";

export default {
	props: {
		item: {type: String, required: true},
		label: {type: String, required: true},
		errors: {type: Object, required: false}
	},
	computed: {
		error() {
			return get(this.errors, `${this.item}[0]`);
		}
	}
};
</script>

<style lang="scss" scoped>
.item {
	margin-bottom: em(32);

	&:last-child {
		margin-bottom: 0;
	}

	.label {
		display: block;
		font-size: 12px;
		font-weight: 500;
		margin-bottom: 8px;
	}

	.error {
		color: $red1;
		font-size: 12px;
		margin-top: 0.5em;
	}
}
</style>
